/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Template_Not_EnabledInputs */

const vi_error_zns_template_not_enabled = /** @type {(inputs: Error_Zns_Template_Not_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu chưa ở trạng thái "Đã duyệt" (hoặc không còn trên Zalo) — chọn mẫu đã duyệt.`)
};

/**

* @param {Error_Zns_Template_Not_EnabledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_template_not_enabled = /** @type {((inputs?: Error_Zns_Template_Not_EnabledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Template_Not_EnabledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_template_not_enabled(inputs)
});